/**
 * 排出事業者の検索ダイアログ
 */
import Vue from "vue";
import * as httpConst from "../../../../../constants/httpConst";

const master_search_emission_detail = {
  namespaced: true,
  actions: {
    /**
     *
     * @param commit
     * @param params
     * @property mode { string } モード: emission or emissionLocation
     * @property free_word { string } 排出事業者名称, 排出事業場名称, 排出事業者コード, 排出事業場コード(排出事業者のみ)
     * @property code { string } 事業場コード
     * @property subscriber_no { string } 加入者番号
     * @property name { string } 名称
     * @property zip_code { string } 郵便番号
     * @property prefecture_code { string } 都道府県コード
     * @property address { string } 住所
     * @property phone_number { string } 電話番号
     * @property manifest_type { string } マニフェスト区分
     * @property emission_filter { string } 排出事業者絞り込みキーワード
     * @property memo { string }メモ
     // * @property location_code { string } emissionモード時の事業場コード
     // * @property location_name { string } emissionモード時の事業場名称
     * @property page { number } ページ番号
     * @return {Promise<unknown>}
     */
    index({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http
          .get(`${httpConst.DRIVER_ENDPOINT}/masters/search/emission_details`, {
            params: params,
          })
          .then((data) => {
            let content = data.content;
            resolve(content);
          });
      });
    },
    show({ commit }, { emission_id, emission_location_id }) {
      const params = { emission_location_id: emission_location_id };
      return new Promise((resolve) => {
        Vue.$http
          .get(
            `${httpConst.DRIVER_ENDPOINT}/masters/search/emission_details/${emission_id}`,
            { params: params }
          )
          .then((data) => {
            let content = data.content;
            resolve(content);
          });
      });
    },
  },
};

export default master_search_emission_detail;
